// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__JSHJ6","summary":"CartItem_summary__1g5Cl","price":"CartItem_price__iDl4L","amount":"CartItem_amount__YfQDb","actions":"CartItem_actions__jH-2A"};